import React from 'react'
import { CardElement } from '@stripe/react-stripe-js'

class CardSection extends React.Component {
  render() {
    return <CardElement options={{ style: { base: { color: 'white' } } }} />
  }
}

export default CardSection
